import { useState } from 'react';
import classNames from 'classnames';

function ChoiceTopModel({selectedData, setModelTop, setModelValance, setModelFringe}) {
	const [activeIndex, setActiveIndex] = useState(0);

	const handleModelSelection = (item, index) => {
		setActiveIndex(index);
		setModelTop(() => item);
		setModelValance({});
		setModelFringe({});
	}

	if (!selectedData) {
		return null;
	}

	return (
		<div className="choices">
			<ul>
				{selectedData.parts.top.list.map((item, index) => (
					<li key={index}>
						<a
							onClick={(e) => {
								e.preventDefault();
								handleModelSelection(item, index)
							}}
							className={classNames('preview decor-checkbox', { 'is-active': activeIndex === index })}
							href={item.model}
						>
							<picture className="preview__media">
								<img src={item.preview} alt={item.name} />
							</picture>

							<div className="preview__content">
								<h6>{item.name}</h6>
							</div>
						</a>
					</li>
				))}
			</ul>
		</div>
	);
}

export default ChoiceTopModel;